export function isEnabledFlag(value: unknown): boolean {
    const normalized = String(value ?? '').trim().toLowerCase();
    return ['true', '1', 'yes', 'on', 'enabled'].includes(normalized);
}

